import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/home';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div>
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <span className="font-heading text-xl font-bold text-background-50">91豆花</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {t('footer.brand_desc')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.quick_links')}</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer">{t('nav.home')}</Link>
              </li>
              <li>
                <Link to="/category/tian-douhua" className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer">{t('nav.categories')}</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer">{t('nav.about')}</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.categories')}</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{t('footer.contact_us')}</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-sm text-primary-400 mt-0.5"></i>
                <span className="text-sm text-foreground-300">400-910-0000</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-sm text-primary-400 mt-0.5"></i>
                <span className="text-sm text-foreground-300">contact@91douhua.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-sm text-primary-400 mt-0.5"></i>
                <span className="text-sm text-foreground-300">中国四川省成都市锦江区东大街168号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">{t('footer.copyright')}</p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="WeChat">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="Weibo">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="Douyin">
              <i className="ri-tiktok-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}